export default __webpack_public_path__ + "static/media/nftDetailMb2.0d647682.png";